import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";

export enum CaptionLength {
  Short = "short",
  Normal = "normal",
  Long = "long",
}

export function captionLengthFromString(s: string): CaptionLength {
  if (s === "short") return CaptionLength.Short;
  if (s === "normal") return CaptionLength.Normal;
  if (s === "long") return CaptionLength.Long;
  throw new Error(`Invalid caption length: ${s}`);
}

export interface PromptOptions {
  length: CaptionLength;
  reasoning?: boolean;
}

export default function PromptCaption({
  setPromptOptions,
  promptOptions,
}: {
  setPromptOptions: (options: PromptOptions) => void;
  promptOptions: PromptOptions;
}) {
  return (
    <div className="flex flex-row gap-2 items-center mb-4 w-full">
      <p className="text-sm">Caption length:</p>
      <RadioGroup
        value={promptOptions.length}
        onValueChange={(value) =>
          setPromptOptions({
            ...promptOptions,
            length: captionLengthFromString(value),
          })
        }
        className="flex gap-4"
        defaultValue={CaptionLength.Short}
      >
        <div className="flex items-center space-x-2">
          <RadioGroupItem value={CaptionLength.Short} id="caption-short" />
          <Label htmlFor="caption-short" className="cursor-pointer">
            Short
          </Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value={CaptionLength.Normal} id="caption-normal" />
          <Label htmlFor="caption-normal" className="cursor-pointer">
            Normal
          </Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value={CaptionLength.Long} id="caption-long" />
          <Label htmlFor="caption-long" className="cursor-pointer">
            Long
          </Label>
        </div>
      </RadioGroup>
    </div>
  );
}
